import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type SubmitManualCorrectionRequest = {
  laboratoryId: string; // "key" dans l'UI
  baseClassName: string; // item.baseClassName
  typeOfError: string;
  original: {
    line?: number;
    column?: string | null;
    error?: string;
    solution?: string;
    suggestion?: string;
    ai_ok?: boolean;
    content?: string;
    value?: string;
  };
  correctedContent: string; // valeur de l'input
};

export const submitManualCorrection = createAppAsyncThunk<void, SubmitManualCorrectionRequest>(
  "formStep/submitManualCorrection",
  async ({ laboratoryId, baseClassName, original, correctedContent, typeOfError }, { getState, extra, dispatch, rejectWithValue }) => {
    try {
      const { selectedEtlImportUuid } = getState().etlData;
      if (!selectedEtlImportUuid) return rejectWithValue("Aucun import sélectionné");

      await extra.etlClient.trigger(EtlApiTarget.CORRECT_CSV_LINE_MANUALLY_API, selectedEtlImportUuid, {
        laboratoryId,
        baseClassName,
        typeOfError,
        original,
        correctedContent,
      });

      dispatch(postToast({ type: ToastType.SUCCESS, message: "Correction manuelle envoyée" }));
    } catch (error: any) {
      dispatch(displayApiErrorToast(error.response));
      return rejectWithValue(error.response?.data?.message ?? "Erreur inconnue");
    }
  }
);


